/**
 * Layout slot component — a placeholder area within a layout.
 * Used to mark where future content will be placed without
 * introducing business-specific markup.
 */

import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface LayoutSlotProps {
  name: string;
  children?: ReactNode;
  className?: string;
}

export function LayoutSlot({ name, children, className }: LayoutSlotProps): JSX.Element {
  return (
    <div
      data-layout-slot={name}
      className={cn(
        'flex min-h-[3rem] items-center justify-center rounded-md border border-dashed border-border bg-surface-secondary/50 p-4',
        className,
      )}
    >
      {children || (
        <span className="text-sm text-muted-foreground">{name} placeholder</span>
      )}
    </div>
  );
}
